// 並び替えの切り替え
//
// 同じ基準をもう一度押したら昇順・降順を反転させる。
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'
import { useState } from 'react'

import type { ReceiptSortKey, ReceiptSortOrder } from '@/api/types/receipt'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { cn } from '@/lib/utils'

import { SORT_OPTIONS } from '../receipt-query'

type Props = {
  sort: ReceiptSortKey
  order: ReceiptSortOrder
  onChange: (sort: ReceiptSortKey, order: ReceiptSortOrder) => void
}

export const ReceiptSortMenu = ({ sort, order, onChange }: Props) => {
  const [open, setOpen] = useState(false)

  const handleSelect = (value: ReceiptSortKey) => {
    onChange(value, value === sort && order === 'desc' ? 'asc' : 'desc')
    setOpen(false)
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="shrink-0 gap-1 px-2!" aria-label="並び替え">
          <ArrowUpDown className="size-4" />
          <span className="text-xs">{SORT_OPTIONS.find((option) => option.value === sort)?.label}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-40 p-1">
        {SORT_OPTIONS.map((option) => {
          const isActive = option.value === sort
          const Icon = order === 'asc' ? ArrowUp : ArrowDown
          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={isActive}
              onClick={() => handleSelect(option.value)}
              className={cn(
                'flex w-full items-center justify-between rounded p-2 text-sm hover:bg-white/5',
                isActive && 'text-primary',
              )}
            >
              {option.label}
              {isActive && <Icon className="size-4" />}
            </button>
          )
        })}
      </PopoverContent>
    </Popover>
  )
}
